import { config } from '@/utils/config';
import { MONTHS } from '@/utils/constants';

/**
 * Zwraca listę miesięcy
 *
 * @export
 * @param {number} year
 * @returns {any[]}
 */
export function months(year: number) {
  const now = new Date();
  if (now.getFullYear() > year) {
    return MONTHS;
  }
  return MONTHS.filter(month => month.value <= now.getMonth());
}

/**
 * Zwraca listę lat
 *
 * @export
 * @returns {any[]}
 */
export function getYears() {
  const currentYear = new Date().getFullYear();
  return new Array(currentYear - config.startYear + 1)
    .fill(0)
    .map((_, index) => currentYear - index)
    .map(year => ({ value: year, text: year.toString() }));
}
